"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeApplication_en_us = void 0;
function backofficeApplication_en_us() {
    return {
        "backoffice.applications.navigation.linkeddomains": "Linked Domains",
        "backoffice.applications.navigation.details": "Details",
        "backoffice.applications.navigation.content": "Content",
        "backoffice.applications.navigation.theme": "Theme",
        "backoffice.applications.navigation.preview": "Preview",
        "backoffice.applications.configurations.authorizationtypes.customers": "Customers",
        "backoffice.applications.configurations.authorizationtypes.backofficeusers": "Employees",
        "backoffice.applications.subtitle": "Create applications and host them as websites.",
        "backoffice.applications.all": "all applications",
        "backoffice.applications.domains.remove.buttontext": "Remove Domain",
        "backoffice.applications.domains.confirmremovetitle": "Remove domain ${domain}?",
        "backoffice.applications.domains.confirmremovecontent": "Do you really want to remove the domain ${domain}? Afterwards your application won't be reachable via this domain anymore.",
        "backoffice.applications.errors.domainalreadyadded": "This domain was already added!",
        "backoffice.applications.errors.domainalreadyverifiedinotherapplication": "This domain was already added and verified by another application!",
        "backoffice.applications.errors.verificationfailed": "Unfortunately the domain verification failed"
    };
}
exports.backofficeApplication_en_us = backofficeApplication_en_us;
